/* @flow */

import { NotificationConstants } from '../constants/notification_constants';

const NotificationActionCreators = {
  error: function(error: Object): Object {
    return {
      type: NotificationConstants.NOTIFICATION_ERROR,
      error: error
    };
  },
  disabledError: function(error: Object): Object {
    return {
      type: NotificationConstants.NOTIFICATION_DISABLED_ERROR,
      error: error
    };
  },
  errorDismiss: function(): Object {
    return {
      type: NotificationConstants.NOTIFICATION_ERROR_DISMISS
    };
  },
  resetError: function(error: Object): Object {
    return {
      type: NotificationConstants.NOTIFICATION_RESET_ERROR,
      error: error
    };
  },
  success: function(message: string): Object {
    return {
      type: NotificationConstants.NOTIFICATION_SUCCESS,
      message: message
    };
  },
  successDismiss: function(): Object {
    return {
      type: NotificationConstants.NOTIFICATION_SUCCESS_DISMISS
    };
  },
  setNotFound: function(notFound: boolean): Object {
    return {
      type: NotificationConstants.NOTIFICATION_NOT_FOUND,
      value: notFound
    };
  }
};

export { NotificationActionCreators };
